import { FunctionComponent, ReactElement } from "react";
import Form from "react-bootstrap/Form";
import clsx from "clsx";
import { capitalize } from "lodash";
import { Level, ScoringLevels, ParanoidComponent } from "./@types";
import styles from "./paranoid-mode.module.scss";

interface IRiskToleranceComponentProps {
  name: string;
  iconName: string;
  fieldName: ParanoidComponent;
  score?: ScoringLevels;
  displayMessage?: ReactElement | string;
  level: Level;
  enabled?: boolean;
  showCheckbox: boolean;
  fontIcon?: boolean;
}

const classifications = ["malicious", "suspicious"];

const RiskToleranceComponent: FunctionComponent<
  IRiskToleranceComponentProps
> = ({
  name,
  iconName,
  fieldName,
  score,
  displayMessage,
  level,
  enabled,
  showCheckbox,
  fontIcon = true
}) => {
  const description = score ? (
    classifications.map(c => {
      const classScore = score[c as keyof ScoringLevels];
      return (
        <li key={`${name}-${c}`}>
          Analyses with score above <b>{classScore}</b> will be classified as{" "}
          <b>{capitalize(c)}</b>.
        </li>
      );
    })
  ) : (
    <li key={`${name}-no-impact`}>
      {displayMessage ?? "Doesn't impact final classification."}
    </li>
  );

  const icon = (
    <span
      className={clsx(styles.icon, `icon-${iconName}`, styles[iconName])}
    ></span>
  );
  const subtitle = <span className={styles["card-subtitle"]}>{name}</span>;
  const label = (
    <>
      {icon}
      {subtitle}
    </>
  );

  return (
    <div
      className={clsx(
        styles["card-item"],
        !showCheckbox && fontIcon && `icon-${iconName}`,
        !showCheckbox && !enabled && styles.disabled
      )}
    >
      <span className={showCheckbox ? styles.checkbox : styles.hidden}>
        <Form.Check
          id={`${level}_${fieldName}`}
          type={"checkbox"}
          label={label}
          defaultChecked={enabled}
        />
      </span>
      {!showCheckbox && !fontIcon && icon}
      {!showCheckbox && subtitle}
      <ul className={styles["card-description"]}>{description}</ul>
    </div>
  );
};

export default RiskToleranceComponent;
